import { c as _c } from "react/compiler-runtime";
import { FormControl, FormField, FormItem, FormMessage, useFormField } from "uiShadcn/form";
// import * as Sentry from "@sentry/nextjs";
import { useFormMode } from "forms/contexts/useFormModeContext";
import type { FormCvProps } from "forms/fields/Cv/types";
import useCv from "forms/fields/Cv/useCv";
import { forwardRef } from "react";
import { useIntl } from "react-intl";
// import ComponentErrorFallback from "templates/ComponentErrorFallback";
import { FormModeValues } from "types/formMode";
import type { FormControlType } from "types/formType";
import type { IProperty } from "types/jsonSchema";
import { predefinedFields } from "types/predefinedFields";
import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { FileInput } from "ui/FileInput";
import RequiredIndicator from "ui/RequiredIndicator/RequiredIndicator";
import { cn } from "utils/helpers/cn";
const cvFileTypes = [".doc", ".docx", ".xls", ".xlsx", ".png", ".jpg", ".gif", ".txt", ".csv", ".ppt", ".pdf", ".bmp", ".odt", ".odp", ".ods", ".rtf", ".pptx", ".pages", ".mp3"];
const CvBody = forwardRef<HTMLInputElement, FormCvProps>((t0, ref) => {
  const $ = _c(44);
  let defaultCv;
  let disabled;
  let required;
  let restProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      onChange: t3,
      value: _value,
      validators: t4,
      disabled: t5,
      defaultCv: t6,
      required: t7,
      ...t8
    } = t0;
    t1 = t3;
    t2 = t4;
    disabled = t5;
    defaultCv = t6;
    required = t7;
    restProps = t8;
    $[0] = t0;
    $[1] = defaultCv;
    $[2] = disabled;
    $[3] = required;
    $[4] = restProps;
    $[5] = t1;
    $[6] = t2;
  } else {
    defaultCv = $[1];
    disabled = $[2];
    required = $[3];
    restProps = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const onChange = t1 === undefined ? _temp : t1;
  let t3;
  if ($[7] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const validators = t3;
  const {
    formatMessage
  } = useIntl();
  const {
    error,
    formDescriptionId
  } = useFormField();
  let t4;
  if ($[9] !== onChange || $[10] !== validators) {
    t4 = {
      onChange,
      validators
    };
    $[9] = onChange;
    $[10] = validators;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    onChangeHandler,
    maxSizeInMB,
    allowedExtensions,
    isUploading
  } = useCv(t4);
  const formMode = useFormMode();
  const t5 = !!error;
  let t6;
  if ($[12] !== t5) {
    t6 = cn("pb-n5 text-font-2 text-sm", {
      "text-destructive": t5
    });
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== allowedExtensions || $[15] !== formatMessage) {
    t7 = formatMessage({
      id: "fileFormats"
    }, {
      formats: allowedExtensions
    });
    $[14] = allowedExtensions;
    $[15] = formatMessage;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <p>{t7}</p>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== formatMessage || $[20] !== maxSizeInMB) {
    t9 = formatMessage({
      id: "fileSize"
    }, {
      size: maxSizeInMB
    });
    $[19] = formatMessage;
    $[20] = maxSizeInMB;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== required) {
    t10 = required && <RequiredIndicator />;
    $[22] = required;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <p className="pt-n2 font-bold">{t9}{t10}</p>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== formDescriptionId || $[28] !== t11 || $[29] !== t6 || $[30] !== t8) {
    t12 = <div id={formDescriptionId} className={t6}>{t8}{t11}</div>;
    $[27] = formDescriptionId;
    $[28] = t11;
    $[29] = t6;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cvFileTypes.join(",");
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const t14 = formMode === FormModeValues.Preview || disabled || isUploading;
  let t15;
  if ($[33] !== defaultCv || $[34] !== onChangeHandler || $[35] !== ref || $[36] !== required || $[37] !== restProps || $[38] !== t14) {
    t15 = <FormControl><FileInput ref={ref} {...restProps} required={required} onChange={onChangeHandler} accept={t13} disabled={t14} defaultFile={defaultCv} /></FormControl>;
    $[33] = defaultCv;
    $[34] = onChangeHandler;
    $[35] = ref;
    $[36] = required;
    $[37] = restProps;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FormMessage className="pt-n2" />;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t12 || $[42] !== t15) {
    t17 = <>{t12}{t15}{t16}</>;
    $[41] = t12;
    $[42] = t15;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
});
export function CvField(t0) {
  const $ = _c(14);
  const {
    control,
    jsonData,
    uiData,
    defaultCv
  } = t0;
  const {
    formatMessage
  } = useIntl();
  let t1;
  if ($[0] !== uiData?.elements?.[0]?.required) {
    t1 = uiData?.elements?.[0]?.required?.includes("true");
    $[0] = uiData?.elements?.[0]?.required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const required = t1;
  const validators = jsonData?.cvFiles?.items?.properties?.id?.["x-validators"];
  let t2;
  if ($[2] !== formatMessage) {
    t2 = formatMessage({
      id: "cvFile"
    });
    $[2] = formatMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== defaultCv || $[5] !== required || $[6] !== validators) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem><CvBody {...field} value={field.value as string} dataTestId="cv-file" required={required} validators={validators} defaultCv={defaultCv} /></FormItem>;
    };
    $[4] = defaultCv;
    $[5] = required;
    $[6] = validators;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== control || $[9] !== t3) {
    t4 = <FormField control={control} name={predefinedFields.cvFiles} render={t3} />;
    $[8] = control;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <Fieldset title={t2}>{t4}</Fieldset>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export default CvField;
function _temp() {}